
<div id="container" *ngIf="curso$ | async as curso; else loading">

    <mat-card>
        <mat-card-header>
            <mat-card-title>{{curso.titulo}}</mat-card-title>
            
        </mat-card-header>
        <mat-divider></mat-divider>
        <img  [src]="curso.imagen" style="width: 100%;">
        <mat-card-content> 
            
            <pre wrap="hard" style="color: #FFF;">{{curso.content}}</pre>
            
        </mat-card-content>
       
        <mat-card-footer>
            Compartir
            
            <br>
            &nbsp; &nbsp; <a href="https://twitter.com/intent/tweet?text={{curso.titulo}}&url={{link}}&hashtags=Astronomium" target="_blank"><i class="fa fa-twitter fa-2x" aria-hidden="true"></i></a>
        </mat-card-footer>
    

    </mat-card>
</div>

 <ng-template #loading>
    
    <div id="load">
    
        <!--  <div class="container-spinner">
            <mat-spinner color="accent"></mat-spinner>
         </div> -->
         <!-- <img src="../../../assets/spinner.gif" alt="" id="imagenSpin"> -->
         Cargando...
     </div>
</ng-template>

